import FlexPane from './_flex-pane.js'
import MenuRow from './_menu-row.js'
import MarketGroupSelector from './_market-group-selector.js'

export default {
  name: 'EventMarketsGroupSwitcher',
  values: {
    container: {
      configSet: FlexPane,
      configValues: {
        style: {
          flexDirection: 'column',
          padding: '0 0 8px',
          _mobile_padding: '0',
        },
      },
    },
    marketGroupCategories: [
    ],
    hideSingleCategory: true,
    categoryContainer: {
      configSet: FlexPane,
      configValues: {
        style: {
          padding: '0 0 4px 0',
        },
      },
    },
    categorySelector: {
      configSet: MenuRow,
      configValues: {
        style: {
          container: {
            padding: '0px',
            width: '100%',
          },
        },
        buttonScrollPane: {
          contentContainer: {
            style: {
              padding: '0px',
            },
          },
        },
        item: {
          unselected: {
            style: {
              base: {
                flexGrow: 0,
                minWidth: '70px',
                padding: '0 8px',
              },
            },
          },
          selected: {
            style: {
              base: {
                flexGrow: 0,
                minWidth: '70px',
                padding: '0 8px',
              },
            },
          },
        },
      },
    },
    groupContainer: {
      configSet: FlexPane,
      configValues: {
        style: {
          padding: '8px 0 0 0',
        },
      },
    },
    groupSelector: {
      configSet: MarketGroupSelector,
      configValues: {},
    },
  },
  meta: {
    extendable: false,
  },
}
